(() => {
  'use strict';

  if (window.__HXYZ_FREE_ASSISTANT__) return;
  window.__HXYZ_FREE_ASSISTANT__ = true;

  const CATEGORIES = {
    motor: ['motor', 'motors', 'brushless motor'],
    frame: ['frame', 'frames'],
    propeller: ['propeller', 'propellers', 'props'],
    battery: ['battery', 'batteries', 'lipo', 'li-ion'],
    esc: ['esc', 'electronic speed controller'],
    gps: ['gps', 'gnss'],
    camera: ['fpv camera', 'camera'],
    goggles: ['fpv goggles', 'goggles'],
    antenna: ['antenna', 'antennae'],
    receiver: ['radio receiver', 'receiver'],
    transmitter: ['radio controller', 'remote controller', 'transmitter'],
    charger: ['battery charger', 'charger'],
    servo: ['servo', 'servo motor'],
    gimbal: ['gimbal'],
    'flight controller': ['flight controller', 'pixhawk', 'cuav'],
    'drone kit': ['drone kit', 'quadcopter kit', 'complete kit'],
    drone: ['drone', 'quadcopter', 'hexacopter', 'uav']
  };

  const normalize = value =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\p{L}\p{N}\s.-]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  function getIntent(query) {
    const q = normalize(query);
    const intent = {
      category: '',
      inch: '',
      contextSize: '',
      sizeAppliesToTarget: false,
      specs: [],
      maxPrice: null,
      keywords: q
    };

    const targetPatterns = [
      {
        category: 'motor',
        patterns: [
          /\bwhich motor\b/i, /\bwhat motor\b/i,
          /\bkaunsa motor\b/i, /\bkaunsi motor\b/i,
          /\bkonsa motor\b/i, /\bmotor lagega\b/i,
          /\bmotor lagegi\b/i, /\bmotor lagana chahiye\b/i,
          /\bmotor recommend\b/i, /\bmotors? for\b/i
        ]
      },
      {
        category: 'frame',
        patterns: [
          /\bwhich frame\b/i, /\bwhat frame\b/i,
          /\bkaunsa frame\b/i, /\bkaunsi frame\b/i
        ]
      },
      {
        category: 'propeller',
        patterns: [
          /\bwhich propellers?\b/i, /\bwhat propellers?\b/i,
          /\bkaunsa propeller\b/i, /\bkaunsi propeller\b/i,
          /\bkaunse props\b/i
        ]
      },
      {
        category: 'battery',
        patterns: [
          /\bwhich battery\b/i, /\bwhat battery\b/i,
          /\bkaunsi battery\b/i, /\bkaunsa battery\b/i
        ]
      },
      {
        category: 'esc',
        patterns: [
          /\bwhich esc\b/i, /\bwhat esc\b/i,
          /\bkaunsa esc\b/i, /\bkaunsi esc\b/i
        ]
      },
      {
        category: 'charger',
        patterns: [
          /\bwhich charger\b/i, /\bwhat charger\b/i,
          /\bkaunsa charger\b/i, /\bkaunsi charger\b/i
        ]
      },
      {
        category: 'gps',
        patterns: [
          /\bwhich gps\b/i, /\bwhat gps\b/i,
          /\bkaunsa gps\b/i, /\bkaunsi gps\b/i
        ]
      }
    ];

    for (const target of targetPatterns) {
      if (target.patterns.some(pattern => pattern.test(q))) {
        intent.category = target.category;
        break;
      }
    }

    if (!intent.category) {
      for (const [category, aliases] of Object.entries(CATEGORIES)) {
        if (aliases.some(alias => {
          const escaped = alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          return new RegExp('\\b' + escaped + '\\b', 'i').test(q);
        })) {
          intent.category = category;
          break;
        }
      }
    }

    const sizeMatch = q.match(
      /\b(2\.5|3\.5|4\.5|5\.5|6\.5|7\.5|2|3|4|5|6|7|8|9|10|11|12)\s*(?:inch(?:es)?|inches|in|इंच)\b/i
    );

    if (sizeMatch) {
      intent.inch = sizeMatch[1];

      const sizeIndex = sizeMatch.index || 0;
      const beforeSize = q.slice(Math.max(0, sizeIndex - 35), sizeIndex);
      const afterSize = q.slice(
        sizeIndex + sizeMatch[0].length,
        sizeIndex + sizeMatch[0].length + 35
      );

      const sizeContext = beforeSize + ' ' + afterSize;

      const contextPatterns = [
        { category: 'frame', pattern: /\bframes?\b/i },
        { category: 'motor', pattern: /\bmotors?\b/i },
        { category: 'propeller', pattern: /\b(props|propellers?)\b/i },
        { category: 'drone', pattern: /\b(drone|quadcopter|hexacopter)\b/i }
      ];

      const sizeCategory = contextPatterns.find(item =>
        item.pattern.test(sizeContext)
      );

      if (sizeCategory && sizeCategory.category === intent.category) {
        intent.sizeAppliesToTarget = true;
      } else {
        intent.contextSize = intent.inch;
      }
    }

    const specPatterns = [
      /\b\d{3,5}\s*kv\b/ig,
      /\b\d+\s*s\b/ig,
      /\b\d{3,6}\s*mah\b/ig,
      /\b\d+(?:\.\d+)?\s*v\b/ig,
      /\b\d+(?:\.\d+)?\s*a\b/ig
    ];

    for (const pattern of specPatterns) {
      (q.match(pattern) || []).forEach(spec => {
        intent.specs.push(spec.replace(/\s+/g, ''));
      });
    }

    const priceMatch = q.match(
      /(?:under|below|less than|within|ke neeche|se kam)\s*(?:rs\.?|inr|₹)?\s*([\d,]+)/
    );

    if (priceMatch) {
      intent.maxPrice = Number(priceMatch[1].replace(/,/g, ''));
    }

    intent.keywords = q
      .replace(
        /\b(show me|show|find|search for|search|i need|i want|looking for|please|give me|do you have|can you show|mujhe|chahiye|dikhao|dikhaiye|batao|kharidna hai|which|what|kaunsa|kaunsi|konsa|konsi|compatible|suitable|recommend|lagana|lagega|lagegi|for|the|a|an|ke|saath|sath|hai|hain|kya|ka|ki|mein|me|under|below|less than|ke neeche|se kam)\b/gi,
        ' '
      )
      .replace(/\s+/g, ' ')
      .trim();

    return intent;
  }

  function productText(product) {
    const tags = Array.isArray(product.tags)
      ? product.tags.join(' ')
      : product.tags || '';

    const variants = (product.variants || []).map(variant =>
      [
        variant.title,
        variant.sku,
        variant.option1,
        variant.option2,
        variant.option3
      ].join(' ')
    ).join(' ');

    return normalize([
      product.title,
      product.product_type,
      product.type,
      product.vendor,
      tags,
      product.description,
      product.body_html,
      variants
    ].join(' '));
  }

  function matchesCategory(product, category) {
    if (!category) return true;

    const aliases = CATEGORIES[category];
    if (!aliases) return true;

    const text = normalize([
      product.title,
      product.product_type,
      product.type,
      Array.isArray(product.tags)
        ? product.tags.join(' ')
        : product.tags || ''
    ].join(' '));

    return aliases.some(alias => {
      const escaped = alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp('\\b' + escaped + '\\b', 'i').test(text);
    });
  }

  function matchesSize(product, inch) {
    if (!inch) return true;

    const text = productText(product);
    const number = inch.replace('.', '\\.');

    const pattern = new RegExp(
      '\\b' + number + '\\s*(?:inch(?:es)?|in)\\b',
      'i'
    );

    return pattern.test(text) || new RegExp(
      '\\b' + number + '\\s*["″]',
      'i'
    ).test(text);
  }

  function getPrice(product) {
    const prices = (product.variants || [])
      .map(variant => Number(variant.price))
      .filter(price => Number.isFinite(price) && price >= 0);

    return prices.length ? Math.min(...prices) / 100 : null;
  }

  async function enrichProduct(product) {
    if (!product.handle || product.__full) return product;

    try {
      const response = await fetch(
        '/products/' + encodeURIComponent(product.handle) + '.js',
        { headers: { Accept: 'application/json' } }
      );

      if (response.ok) {
        const full = await response.json();

        return {
          ...product,
          ...full,
          url: product.url || full.url ||
            '/products/' + product.handle,
          __full: true
        };
      }
    } catch (error) {
      console.warn('Product details unavailable:', error);
    }

    return product;
  }

  async function shopifySearch(term) {
    const url =
      '/search/suggest.json?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=last';

    const response = await fetch(url, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return [];

    const data = await response.json();

    return data.resources?.results?.products || [];
  }

  function hxyzNormalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function hxyzLinkMatches(label, query) {
    const a = hxyzNormalize(label);
    const b = hxyzNormalize(query);
    if (!a || !b || a.length < 2 || b.length < 2) return false;
    return a === b || a.includes(b) || b.includes(a);
  }

  async function shopifyContentSearch(term) {
    const collected = new Map();

    const types = [
      { request: 'collection', result: 'collections', label: 'Collection' },
      { request: 'page', result: 'pages', label: 'Website Page' },
      { request: 'article', result: 'articles', label: 'Blog Article' }
    ];

    for (const type of types) {
      try {
        const url =
          '/search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=' + type.request +
          '&resources[limit]=10';

        const response = await fetch(url, {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) continue;

        const data = await response.json();
        const items = data.resources?.results?.[type.result] || [];

        items.forEach(item => {
          if (!item.url || !item.title) return;

          collected.set(item.url, {
            title: item.title,
            url: item.url,
            type: type.label
          });
        });
      } catch (error) {
        console.warn('Website content search failed:', type.request, error);
      }
    }

    document.querySelectorAll(
      'header a, nav a, footer a, .footer a'
    ).forEach(link => {
      const title = (
        link.getAttribute('aria-label') ||
        link.textContent ||
        link.querySelector('img')?.alt ||
        link.title ||
        ''
      ).trim().replace(/\s+/g, ' ');

      const href = link.getAttribute('href');

      if (!href || !title || !hxyzLinkMatches(title, term)) return;
      if (/^(javascript:|mailto:|tel:|#)/i.test(href)) return;

      let type = 'Website Page';

      if (href.includes('/collections/')) type = 'Collection';
      else if (href.includes('/blogs/')) type = 'Blog Article';

      collected.set(href, { title, url: href, type });
    });

    return Array.from(collected.values());
  }

  async function shopifyBrandSearch(term) {
    const results = [];
    const query = hxyzNormalize(term);

    if (!query) return results;

    try {
      const response = await fetch('/pages/all-brands', {
        headers: { Accept: 'text/html' }
      });

      if (!response.ok) return results;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const seen = new Set();

      doc.querySelectorAll('a[href]').forEach(link => {
        const img = link.querySelector('img');

        const label = [
          link.getAttribute('aria-label'),
          link.getAttribute('title'),
          img?.getAttribute('alt'),
          img?.getAttribute('title'),
          link.textContent
        ].filter(Boolean).join(' ').trim().replace(/\s+/g, ' ');

        const href = link.getAttribute('href');

        if (!href || !label || !hxyzLinkMatches(label, term)) return;
        if (/^(javascript:|mailto:|tel:|#)/i.test(href)) return;

        const absolute = new URL(href, window.location.origin).href;

        if (seen.has(absolute)) return;

        seen.add(absolute);

        results.push({
          title: label,
          url: absolute,
          type: 'Brand'
        });
      });
    } catch (error) {
      console.warn('Brand page search failed:', error);
    }

    if (!results.length) {
      const knownBrands = [
        'AKK','Amass','AocodaRC','Artillery','ATOMRC','AXIS','Benewake',
        'BETAFPV','Blackberry','KONKA','CaddxFPV','Champion','CNHL',
        'CoreWing','Creality','CUAV','CubePilot','Cyclone','DakeFPV',
        'DarkMatter','DJI','Duracell','Eachine','EFT','EMAX','FLYSKY',
        'FOXEER','Gemfan','GenX','Generic','Gens ace','GN3','HGLRC',
        'Hobbywing','Holybro','HOTA','HQProp','iFlight','IMAX','Jumper',
        'LANRC','Matek','MicroAir','Noel','NV Track','Orange','Panasonic',
        'RadioLink','RadioMaster','RajShri','Readytosky','RunCam','SIYI',
        'SKYDROID','SKYSTARS','SKYZONE','SpeedyBee','SURPASS HOBBY',
        'T-Motor','TAPARIA','TAROT','Tattu','ToolkitRC','TowerPro',
        'VIFLY','Walksnail'
      ];

      const brand = knownBrands.find(
        name => hxyzNormalize(name) === query
      );

      if (brand) {
        results.push({
          title: brand,
          url: '/collections/vendors?q=' + encodeURIComponent(brand),
          type: 'Brand'
        });
      }
    }

    return results;
  }

  async function searchProducts(query, intent) {
    const terms = [];

    if (intent.category) {
      terms.push(intent.category);

      if (intent.inch && intent.sizeAppliesToTarget) {
        terms.push(intent.inch + ' inch ' + intent.category);
      }
    }

    if (intent.specs.length) {
      terms.push(intent.specs.join(' '));
    }

    if (intent.keywords) {
      terms.push(intent.keywords);
    }

    terms.push(query);

    const uniqueTerms = [...new Set(
      terms.map(term => String(term || '').trim()).filter(Boolean)
    )].slice(0, 5);

    const collected = new Map();

    for (const term of uniqueTerms) {
      try {
        const products = await shopifySearch(term);

        products.forEach(product => {
          const key = product.handle || product.url || product.title;

          if (key && !collected.has(key)) {
            collected.set(key, product);
          }
        });
      } catch (error) {
        console.warn('Store search failed:', error);
      }
    }

    let products = Array.from(collected.values());

    products = await Promise.all(
      products.slice(0, 30).map(enrichProduct)
    );

    if (intent.category) {
      products = products.filter(product =>
        matchesCategory(product, intent.category)
      );
    }

    if (intent.sizeAppliesToTarget && intent.inch) {
      products = products.filter(product =>
        matchesSize(product, intent.inch)
      );
    }

    if (intent.specs.length) {
      products = products.filter(product => {
        const text = productText(product).replace(/\s/g, '');

        return intent.specs.every(spec =>
          text.includes(spec.replace(/\s/g, ''))
        );
      });
    }

    if (intent.maxPrice !== null) {
      products = products.filter(product => {
        const price = getPrice(product);
        return price !== null && price <= intent.maxPrice;
      });
    }

    products = products.map(product => {
      const text = productText(product);

      const title = normalize([
        product.title,
        product.product_type,
        product.type,
        product.vendor,
        Array.isArray(product.tags)
          ? product.tags.join(' ')
          : product.tags || ''
      ].join(' '));

      let score = 0;

      if (intent.category && matchesCategory(product, intent.category)) {
        score += 100;
      }

      if (intent.inch && matchesSize(product, intent.inch)) {
        score += 30;
      }

      if (intent.contextSize) {
        const sizeForms = [
          intent.contextSize + ' inch',
          intent.contextSize + 'in',
          intent.contextSize + ' inches'
        ];

        if (sizeForms.some(form => text.includes(form))) {
          score += 15;
        }
      }

      intent.keywords.split(/\s+/)
        .filter(word => word.length > 2)
        .forEach(word => {
          if (title.includes(word)) score += 8;
          else if (text.includes(word)) score += 3;
        });

      product.__score = score;
      return product;
    });

    products.sort((a, b) => b.__score - a.__score);

    return products.slice(0, 8);
  }

  function createElement(tag, className, text) {
    const element = document.createElement(tag);

    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;

    return element;
  }

  function init() {
    if (document.getElementById('hxyz-free-assistant')) return;

    const headerIcons = document.querySelector('header .header__icons');

    const host = headerIcons ||
      document.querySelector('header') ||
      document.body;

    const root = createElement('div');
    root.id = 'hxyz-free-assistant';

    root.innerHTML = `
      <button
        type="button"
        class="hxyz-assistant-mic"
        aria-label="Open voice shopping assistant"
        title="Voice Shopping Assistant">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="9" y="2" width="6" height="12" rx="3"></rect>
          <path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8"></path>
        </svg>
      </button>

      <section class="hxyz-assistant-panel" hidden>
        <div class="hxyz-assistant-header">
          <div>
            <strong>Hi Tech XYZ Assistant</strong>
            <div class="hxyz-assistant-subtitle">
              Ask about drone products
            </div>
          </div>
          <button type="button" class="hxyz-assistant-close"
            aria-label="Close assistant">×</button>
        </div>

        <form class="hxyz-assistant-form">
          <input
            type="text"
            class="hxyz-assistant-input"
            placeholder="Ask about motors, batteries, GPS..."
            aria-label="Ask the assistant"
            autocomplete="off">

          <button type="button" class="hxyz-assistant-speak"
            aria-label="Speak your question" title="Speak">🎤</button>

          <button type="submit" class="hxyz-assistant-send">Ask</button>
        </form>

        <div class="hxyz-assistant-status" role="status" aria-live="polite">
          Hi! Ask me to find a product.
        </div>

        <div class="hxyz-assistant-results"></div>

        <div class="hxyz-assistant-footer">
          Free store assistant · Results depend on available store data
        </div>
      </section>
    `;

    const style = document.createElement('style');

    style.textContent = `
      #hxyz-free-assistant {
        position:relative;
        display:inline-flex;
        align-items:center;
        flex-shrink:0;
        z-index:10050;
        font-family:inherit;
      }

      #hxyz-free-assistant * {
        box-sizing:border-box;
      }

      .hxyz-assistant-mic {
        width:44px;
        height:44px;
        border:0;
        border-radius:50%;
        background:transparent;
        color:inherit;
        cursor:pointer;
        display:flex;
        align-items:center;
        justify-content:center;
      }

      .hxyz-assistant-mic:hover {
        background:rgba(127,127,127,.12);
      }

      .hxyz-assistant-mic svg {
        width:23px;
        height:23px;
        fill:none;
        stroke:currentColor;
        stroke-width:1.8;
        stroke-linecap:round;
        stroke-linejoin:round;
      }

      .hxyz-assistant-panel {
        position:absolute;
        top:calc(100% + 10px);
        right:0;
        width:min(390px,90vw);
        max-height:75vh;
        overflow:auto;
        background:#fff;
        color:#222;
        border:1px solid #e4e7ec;
        border-radius:14px;
        box-shadow:0 12px 38px rgba(0,0,0,.18);
        text-align:left;
      }

      .hxyz-assistant-panel[hidden] {
        display:none !important;
      }

      .hxyz-assistant-header {
        display:flex;
        justify-content:space-between;
        align-items:center;
        gap:12px;
        padding:15px;
        background:#f8fafc;
        border-bottom:1px solid #e9edf2;
      }

      .hxyz-assistant-header strong {
        font-size:15px;
      }

      .hxyz-assistant-subtitle {
        font-size:12px;
        margin-top:3px;
        color:#667085;
      }

      .hxyz-assistant-close {
        border:0;
        background:transparent;
        font-size:26px;
        cursor:pointer;
        color:#475467;
      }

      .hxyz-assistant-form {
        display:flex;
        gap:6px;
        padding:12px;
      }

      .hxyz-assistant-input {
        min-width:0;
        flex:1;
        padding:11px;
        border:1px solid #d0d5dd;
        border-radius:8px;
        font:inherit;
        font-size:13px;
      }

      .hxyz-assistant-speak,
      .hxyz-assistant-send {
        border:0;
        border-radius:8px;
        padding:8px 11px;
        cursor:pointer;
      }

      .hxyz-assistant-speak {
        background:#eaf2ff;
        font-size:17px;
      }

      .hxyz-assistant-send {
        background:#1769e0;
        color:#fff;
        font-size:13px;
      }

      .hxyz-assistant-status {
        padding:0 14px 12px;
        font-size:13px;
        line-height:1.6;
        color:#344054;
        white-space:pre-wrap;
      }

      .hxyz-assistant-results {
        padding:0 12px;
      }

      .hxyz-assistant-product {
        display:flex;
        gap:10px;
        align-items:flex-start;
        padding:11px 2px;
        border-top:1px solid #eee;
        color:#222;
        text-decoration:none;
      }

      .hxyz-assistant-product:hover {
        color:#1769e0;
      }

      .hxyz-assistant-product img {
        width:58px;
        height:58px;
        object-fit:contain;
        flex-shrink:0;
        border:1px solid #eee;
        border-radius:7px;
      }

      .hxyz-assistant-product-title {
        font-size:13px;
        line-height:1.45;
      }

      .hxyz-assistant-product-price {
        font-size:13px;
        font-weight:600;
        margin-top:5px;
      }

      .hxyz-assistant-all {
        display:block;
        margin:12px 0;
        padding:10px;
        border-radius:8px;
        background:#f2f4f7;
        color:#1769e0;
        text-align:center;
        text-decoration:none;
        font-size:13px;
      }

      .hxyz-assistant-footer {
        padding:12px;
        border-top:1px solid #eee;
        color:#667085;
        font-size:11px;
      }

      .hxyz-assistant-mic.is-listening {
        color:#1769e0;
        background:#eaf2ff;
      }

      @media(max-width:480px) {
        .hxyz-assistant-panel {
          position:fixed;
          top:75px;
          right:10px;
          width:calc(100vw - 20px);
          max-height:80vh;
        }
      }
    `;

    document.head.appendChild(style);

    const searchIcon = headerIcons
      ? headerIcons.querySelector('.header__icon--search')
      : null;

    const accountIcon = headerIcons
      ? headerIcons.querySelector('.header__icon--account')
      : null;

    if (headerIcons && searchIcon && accountIcon) {
      accountIcon.insertAdjacentElement('beforebegin', root);
    } else if (searchIcon) {
      searchIcon.insertAdjacentElement('afterend', root);
    } else if (headerIcons) {
      headerIcons.appendChild(root);
    } else {
      host.appendChild(root);
    }

    root.style.display = 'inline-flex';
    root.style.position = 'relative';
    root.style.visibility = 'visible';
    root.style.opacity = '1';
    root.style.flexShrink = '0';
    root.style.width = '36px';
    root.style.height = '44px';
    root.style.margin = '0';
    root.style.padding = '0';
    root.style.alignItems = 'center';
    root.style.justifyContent = 'center';
    root.style.zIndex = '10050';

    const micButton = root.querySelector('.hxyz-assistant-mic');
    const panel = root.querySelector('.hxyz-assistant-panel');
    const closeButton = root.querySelector('.hxyz-assistant-close');
    const input = root.querySelector('.hxyz-assistant-input');
    const form = root.querySelector('.hxyz-assistant-form');
    const speakButton = root.querySelector('.hxyz-assistant-speak');
    const status = root.querySelector('.hxyz-assistant-status');
    const resultsBox = root.querySelector('.hxyz-assistant-results');

    function setStatus(message) {
      status.textContent = message;
    }

    function speak(message, language = 'en-IN') {
      if (!('speechSynthesis' in window)) return;

      window.speechSynthesis.cancel();

      const utterance = new SpeechSynthesisUtterance(message);
      utterance.lang = language;
      utterance.rate = 1;

      window.speechSynthesis.speak(utterance);
    }

    function openPanel() {
      panel.hidden = false;
      input.focus();
    }

    function closePanel() {
      panel.hidden = true;
    }

    micButton.addEventListener('click', () => {
      if (panel.hidden) openPanel();
      else closePanel();
    });

    closeButton.addEventListener('click', closePanel);

    document.addEventListener('click', event => {
      if (!root.contains(event.target)) closePanel();
    });

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    let recognition = null;

    if (SpeechRecognition) {
      recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      speakButton.addEventListener('click', () => {
        openPanel();
        recognition.lang = 'en-IN';
        micButton.classList.add('is-listening');
        setStatus('Listening... Please say your question.');

        try {
          recognition.start();
        } catch (error) {
          micButton.classList.remove('is-listening');
          setStatus('Please wait a moment and try again.');
        }
      });

      recognition.onresult = event => {
        const transcript =
          event.results?.[0]?.[0]?.transcript?.trim() || '';

        if (transcript) {
          input.value = transcript;
          setStatus('I heard: ' + transcript);
          handleQuestion(transcript);
        }
      };

      recognition.onerror = event => {
        const messages = {
          'not-allowed':
            'Please allow microphone permission in your browser.',
          'no-speech':
            'No speech detected. Tap the microphone and try again.',
          'network':
            'Speech recognition needs an internet connection.',
          'audio-capture':
            'No microphone detected. Check your device settings.'
        };

        setStatus(
          messages[event.error] ||
          'Voice recognition failed. Please type your question.'
        );
      };

      recognition.onend = () => {
        micButton.classList.remove('is-listening');
      };
    } else {
      speakButton.addEventListener('click', () => {
        setStatus(
          'Voice input is not supported in this browser. Please use Google Chrome or type your question.'
        );
      });
    }

    function renderProducts(products, originalQuery, intent) {
      resultsBox.replaceChildren();

      if (!products.length) {
        setStatus(
          'No matching products found. Try another product name or specification.'
        );

        const allLink = createElement(
          'a',
          'hxyz-assistant-all',
          'Search the full store'
        );

        allLink.href =
          '/search?type=product&q=' +
          encodeURIComponent(originalQuery);

        resultsBox.appendChild(allLink);
        return;
      }

      if (intent.contextSize && intent.category === 'motor') {
        setStatus(
          'Here are matching motor products for your search. Please verify the motor, propeller, frame size and battery compatibility in the product specifications.'
        );
      } else {
        setStatus(
          'I found ' + products.length +
          ' possible product match(es). Please check the product specifications before ordering.'
        );
      }

      products.forEach(product => {
        const link = createElement('a', 'hxyz-assistant-product');

        link.href =
          product.url ||
          '/products/' + encodeURIComponent(product.handle || '');

        const imageUrl =
          product.featured_image ||
          product.image ||
          product.featured_image?.url;

        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.title || 'Product image';
          image.loading = 'lazy';
          link.appendChild(image);
        }

        const details = createElement('div');

        details.appendChild(
          createElement(
            'div',
            'hxyz-assistant-product-title',
            product.title || 'View product'
          )
        );

        const price = getPrice(product);

        if (price !== null) {
          details.appendChild(
            createElement(
              'div',
              'hxyz-assistant-product-price',
              '₹' + price.toLocaleString('en-IN')
            )
          );
        }

        link.appendChild(details);
        resultsBox.appendChild(link);
      });

      const allLink = createElement(
        'a',
        'hxyz-assistant-all',
        'View more search results'
      );

      allLink.href =
        '/search?type=product&q=' +
        encodeURIComponent(originalQuery);

      resultsBox.appendChild(allLink);
    }

    async function handleQuestion(question) {
      const query = String(question || '').trim();

      if (!query) {
        setStatus('Please type or say a question first.');
        return;
      }

      openPanel();
      resultsBox.replaceChildren();

      const intent = getIntent(query);

      if (/^(hi|hello|hey|namaste|namaskar|salam)$/i.test(query)) {
        const reply =
          'Hello! Welcome to Hi Tech xyz. Ask me about products, brands, collections, categories, pages or store policies.';
        setStatus(reply);
        speak(reply);
        return;
      }

      if (/^(help|how to use|what can you do)$/i.test(query)) {
        const reply =
          'You can search for products, SKU, brands, collections, categories, website pages, policies and blogs.';
        setStatus(reply);
        speak(reply);
        return;
      }

      setStatus('Searching products and website information...');

      try {
        const productsPromise = searchProducts(query, intent);
        const contentPromise = shopifyContentSearch(query);
        const brandPromise = shopifyBrandSearch(query);

        const [products, content, brands] = await Promise.all([
          productsPromise,
          contentPromise,
          brandPromise
        ]);

        const allSiteResults = [];
        const seen = new Set();

        [...brands, ...content].forEach(item => {
          if (!item?.url || seen.has(item.url)) return;
          seen.add(item.url);
          allSiteResults.push(item);
        });

        const exactSiteResults = allSiteResults.filter(item =>
          hxyzLinkMatches(item.title, query)
        );

        const siteResults = exactSiteResults.length
          ? exactSiteResults
          : allSiteResults;

        const hasExactNonProduct = exactSiteResults.length > 0;

        if (!hasExactNonProduct) {
          renderProducts(products, query, intent);
        }

        if (siteResults.length) {
          if (hasExactNonProduct) resultsBox.replaceChildren();

          const heading = createElement(
            'div',
            'hxyz-assistant-product-title',
            'Matching Website Results'
          );

          heading.style.margin = '12px 0 8px';
          resultsBox.appendChild(heading);

          siteResults.slice(0, 12).forEach(item => {
            const link = createElement(
              'a',
              'hxyz-assistant-all',
              (item.type === 'Brand' ? 'Open Brand: ' :
               item.type === 'Collection' ? 'Open Collection: ' :
               item.type === 'Blog Article' ? 'Open Blog: ' :
               'Open Page: ') + item.title
            );

            link.href = item.url;
            link.style.display = 'block';
            link.style.padding = '12px';
            link.style.margin = '7px 0';
            link.style.border = '1px solid #e5e7eb';
            link.style.borderRadius = '8px';
            link.style.textDecoration = 'none';
            link.style.color = 'inherit';

            resultsBox.appendChild(link);
          });

          setStatus(
            'I found matching website links. Select a result to open it.'
          );
        } else if (products.length) {
          // Product cards already displayed.
        } else {
          setStatus(
            'No exact match found. Try another keyword or use full store search.'
          );

          const link = createElement(
            'a',
            'hxyz-assistant-all',
            'Search the full website'
          );

          link.href = '/search?q=' + encodeURIComponent(query);
          resultsBox.appendChild(link);
        }

        if (products.length && !hasExactNonProduct) {
          speak(
            'I found ' + products.length +
            ' possible matching products. Please check the product details on the website.',
            'en-IN'
          );
        } else if (hasExactNonProduct) {
          speak('I found a matching website link.', 'en-IN');
        }
      } catch (error) {
        console.error('Hi Tech xyz assistant error:', error);

        setStatus('I could not complete the search. Please try again.');

        const link = createElement(
          'a',
          'hxyz-assistant-all',
          'Open website search'
        );

        link.href = '/search?q=' + encodeURIComponent(query);
        resultsBox.appendChild(link);
      }
    }

    form.addEventListener('submit', event => {
      event.preventDefault();
      handleQuestion(input.value);
    });
  }

  function start() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  }

  start();

  window.addEventListener('load', () => {
    if (!document.getElementById('hxyz-free-assistant')) {
      init();
    }
  });
})();